<template>
  <v-app>
    <topBar></topBar>
    <br /><br /><br /><br /><br /><br /><br /><br /><br />
    <v-container>
      <v-row align="center" justify="center">
          <v-col cols="12" sm="10">
            <v-card>
              <v-card-title>
                <h1>Fontaneria</h1>
              </v-card-title>
              <v-card-text>
                <p>
              ¡Bienvenido a HM Reformas! Somos la solución integral
              para tus necesidades de fontanería en el hogar. Con
              especialización en servicios fontaneros, estamos aquí para
              asegurar que tu hogar cuente con instalaciones de agua eficientes
              y sin problemas.
            </p>

            <p>
              En HM Reformas, nos enorgullece ofrecer una amplia
              variedad de servicios de fontanería para el hogar. Desde la
              instalación de nuevas tuberías hasta la reparación de fugas,
              nuestro equipo de expertos está capacitado para abordar todas tus
              necesidades relacionadas con la fontanería.
            </p>

            <p>
              ¿Necesitas instalar un nuevo sistema de fontanería en tu hogar?
              ¿Tienes problemas con las tuberías o necesitas reparar una fuga?
              Estamos aquí para ayudarte. Nuestros servicios incluyen
              instalación y reparación de tuberías, grifos, sistemas de
              calefacción y gestión de desagües.
            </p>

            <p>
              En HM Reformas, comprendemos la importancia de un
              sistema de fontanería eficiente y sin problemas. Nos
              especializamos en identificar y solucionar problemas de
              fontanería, asegurando que el suministro de agua en tu hogar sea
              seguro y confiable. Ya sea que necesites resolver una fuga,
              mejorar la presión del agua o instalar nuevos accesorios, estamos
              listos para actuar.
            </p>

            <p>
              Contáctanos para recibir asesoramiento personalizado y soluciones
              de fontanería adaptadas a tu hogar. En HM Reformas,
              hacemos que la fontanería sea simple, confiable y eficiente.
            </p>

            <p>
              ¡Gracias por considerar a HM Reformas como tu socio en
              soluciones de fontanería para el hogar! Estamos emocionados de
              trabajar contigo para mejorar tu experiencia en casa.
            </p>
              </v-card-text>
            </v-card>
          </v-col>
        

          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="12" sm="10">
            <plumbingGalery />
          </v-col>
          <v-col cols="12" sm="10">
            <formulario />
          </v-col>
          </v-row>
  
    </v-container>
    <sideAlert class="floating-button" />
    <contactVue class="floating-contact" />  <a
            :href="'https://www.facebook.com/profile.php?id=61555855631904&locale=es_ES'"
            target="_blank"
          >
            <v-icon color="teal" class="floating-facebook">mdi-facebook</v-icon>
          </a>
          <a
            :href="'https://www.instagram.com/hernanmorareformas/'"
            target="_blank"
          >
            <v-icon color="red" class="floating-instagram">mdi-instagram</v-icon>
          </a>
  </v-app>
</template>

<script>
import topBar from "@/components/topBar.vue";
import sideAlert from "@/components/sideAlert.vue";
import formulario from "@/components/form.vue";
import plumbingGalery from "@/components/plumbingGalery.vue";
import contactVue from '@/components/contact.vue'
export default {
  name: "App",

  data() {
    return {
      alertInfo: {
        title: "¡Emergencias 24h 7 dias a la semana!",
        message:
          "Si tienes alguna emergencia de electricidad,fontaneria o pequeña averia en tu hogar",
        phone: "617 870 811",
      },
    };
  },

  components: {
    topBar,
    sideAlert,
    formulario,
    plumbingGalery,contactVue
  },
};
</script>
<style scoped>
.mt-4 {
  margin-top: 50%; 
}.floating-button {
  position: fixed;
  bottom: 55%; 
  right: 20px; 
}
.floating-contact{
  position: fixed;
  bottom: 45%; 
  right: 20px; 
}.floating-facebook{
  position: fixed;
  bottom: 35%;
  right: 20px;
}
.floating-instagram{
  position: fixed;
  bottom: 30%;
  right: 20px;
}
</style>
